const getBaseURL = ():string => {
    const baseURL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;

    return baseURL;
}

export default getBaseURL